export default __webpack_public_path__ + "static/media/design_blanc.292d82c7.svg";